import { render, staticRenderFns } from "./ArtistContractsCopy.vue?vue&type=template&id=1f2030e1&scoped=true&"
import script from "./ArtistContractsCopy.vue?vue&type=script&lang=js&"
export * from "./ArtistContractsCopy.vue?vue&type=script&lang=js&"
import style0 from "./ArtistContractsCopy.vue?vue&type=style&index=0&id=1f2030e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2030e1",
  null
  
)

export default component.exports